import React from "react";

const GeneralLedger = () => {
  return <div>GeneralLedger</div>;
};

export default GeneralLedger;
